import type { FC } from 'react';
import { styled } from 'goober';

import type { FlexBoxProps } from '@/ui/flexbox/flexbox';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { SmallText } from '@/ui/typography/action-panel';

interface Props extends FlexBoxProps {
  label: string;
  position?: 'top' | 'bottom';
}

export const FormLabel: FC<Props> = ({
  children,
  name,
  label,
  position = 'bottom',
  ...props
}) => {
  return (
    <Container name={name} direction="column" gap="6px" {...props}>
      {position === 'top' && <Label>{label}</Label>}
      {children}
      {position === 'bottom' && <Label>{label}</Label>}
    </Container>
  );
};

const Container = styled(Flexbox)`
  position: relative;
`;

const Label = styled(SmallText)`
  margin-left: 10px;
`;
